import Container from 'react-bootstrap/Container';
import { splitLastWord } from '../SectionHeading/SectionHeading';

// Faint concentric rings bleeding off the right side of the band.
function HeroAccent() {
    return (
        <svg className="page-hero__accent" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
            {[190, 150, 110, 70].map(r => <circle key={r} className="page-hero__ring" cx="200" cy="200" r={r}/>)}
        </svg>
    );
}

// Deep theme-toned page header shared by inner pages (appointment, gallery, custom pages).
function PageHero({ eyebrow, title, text, meta, overlap = false }) {
    const [lead, word, punctuation] = splitLastWord(title);
    return (
        <section className={'page-hero' + (overlap ? ' page-hero--overlap' : '')}>
            <HeroAccent/>
            <Container className="page-hero__inner">
                {eyebrow ? <span className="page-hero__eyebrow">{eyebrow}</span> : null}
                <h1 className="page-hero__title">{lead}<span className="section-heading__mark">{word}</span>{punctuation}</h1>
                {text ? <p className="page-hero__text">{text}</p> : null}
                {meta ? <div className="page-hero__meta">{meta}</div> : null}
            </Container>
        </section>
    );
}

export default PageHero;
